import React from 'react';
import { Container, Row } from 'shards-react';

const MainFooter = () => {
	const year = new Date().getFullYear();
	return (
		<footer className='main-footer d-flex px-3 bg-white border-top align-items-center'>
			<Container fluid>
				<Row>
					<span className='copyright ml-auto my-auto mr-2'>{`© ${year} Kabema Digital GmbH`}</span>
				</Row>
			</Container>
		</footer>
	);
};

export default MainFooter;
